var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c("wiki-detail-page-slide-container", {
        attrs: {
          "full-screen": _vm.fullScreen,
          "active-slide": _vm.activeSlide,
          "edit-mode": _vm.editMode,
        },
      }),
      _vm._v(" "),
      _c("wiki-detail-page-slide-attachments", {
        attrs: { slide: _vm.activeSlide, "edit-mode": _vm.editMode },
      }),
      _vm._v(" "),
      _c("wiki-detail-page-slider", { attrs: { "edit-mode": _vm.editMode } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }